module.exports = __webpack_public_path__ + "img/target_pin_blue.bf1140d6.svg";